/* React */
import React, { useCallback } from 'react';

/* Interfaces */
import { sendEmail, IEmail } from '../../interfaces/recoverPassword';

/* Styles */
import { Container, Content, FormWrapper } from './styles';

/* antd */
import { Form, message, Input } from 'antd';

/* Components */
import { Header } from '../../components/Header';
import Footer from '../../components/Footer';

/* Assets */
import Coruja from '../../assets/img/pet/corujaSegurandoChapeu.png';

const RecoverPassword: React.FC = () => {
  const [form] = Form.useForm();

  const handleSubmit = useCallback(() => {
    form.submit();
  }, [form]);

  const sendAEmail = useCallback(
    async (data: IEmail) => {
      const response = await sendEmail(data);
      if (response) form.resetFields();
    },
    [form]
  );

  return (
    <Container>
      <Header />
      <Content>
        <main>
          <h1>
            Insira um e-mail abaixo para que possamos recuperar sua senha!
          </h1>
          <FormWrapper>
            <Form
              form={form}
              layout="vertical"
              requiredMark={false}
              onFinish={sendAEmail}
              onFinishFailed={() =>
                message.error('Ocorreu um erro, tente novamente!', 3)
              }
            >
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'Insira seu e-mail!',
                  },
                ]}
              >
                <label>
                  E-mail
                  <Input
                    bordered={false}
                    style={{
                      borderBottom: '1px solid black',
                      marginTop: '5px',
                      fontSize: '18px',
                      padding: '2px 5px 0 5px',
                    }}
                  />
                </label>
              </Form.Item>
            </Form>
          </FormWrapper>
          <button onClick={handleSubmit}>enviar e-mail</button>
        </main>
        <aside>
          <img src={Coruja} alt="Imagem de uma coruja" />
        </aside>
      </Content>
      <Footer />
    </Container>
  );
};

export default RecoverPassword;
